import React from 'react';
import { componentService } from 'js/services/component.service';

export const Balance = React.lazy(() => import(/* webpackChunkName: "user-balance" */ './Balance'));

componentService.registerWebContentComponents({
    Balance,
    BalanceCalc: ({ args }: { args: string }) => <Balance type="balance_calc" args={args}/>,
    BonusBalance: () => <Balance type="bonus_balance"/>,
    BonusPendingWinnings: () => <Balance type="bonus_pending_winnings"/>,
    CasinoGamingBalance: () => <Balance type="casino_gaming_balance"/>,
    RealGamingBalance: () => <Balance type="real_gaming_balance"/>,
    RingfencedRealBalance: () => <Balance type="ringfenced_real_balance"/>,
    TotalBonusBalance: () => <Balance type="total_bonus_balance"/>,
    TotalFreeSpinsBalance: () => <Balance type="free_spin_balance"/>,
    // TODO uncomment after removing deprecated BB replacer TOTAL_GOLDEN_CHIPS_BALANCE 'replacers/total-goldenchips-balance/total-goldenchips-balance.view'
    // TotalGoldenChipsBalance: () => <Balance type="golden_chips_balance"/>,
    WithdrawableBalance: () => <Balance type="withdrawable_balance"/>
});
